<template>
  <div>
    <mdb-list-group class="max-size-long">
      <mdb-list-group-item v-for="q in questions" :key="id + (q.id || Math.random())">
        <span>
          <a @click="useQuestion(q)">
            <mdb-icon icon="reply-all" />
            {{q.question}}
            <br />
            <mdb-badge
              pill
              color="warning"
              v-for="t in q.tags"
              :key="q.id + '-' + t + Math.random()"
            >{{t}}</mdb-badge>
          </a>
        </span>
        <div>
          <div class="progress-min-width">
            <mdb-progress :value="getRatio(q)" color="success" />
            <span>{{(q.voteUp + q.voteDown) || 0}} votes</span>
            <br />
            <span v-if="votable && q.author != $store.state.db.user.id">
              <a @click="$emit('vote-down', q)" class="material-icons">thumb_down</a>
              <a @click="$emit('vote-up', q)" class="material-icons">thumb_up</a>
            </span>
          </div>
          <div v-if="removable">
            <a @click="$emit('remove-question', q)" class="material-icons">clear</a>
          </div>
        </div>
      </mdb-list-group-item>
    </mdb-list-group>
  </div>
</template>

<script>
import {
  mdbListGroup,
  mdbListGroupItem,
  mdbProgress,
  mdbBadge,
  mdbIcon
} from "mdbvue";
export default {
  name: "ListQuestions",
  components: {
    mdbListGroup,
    mdbListGroupItem,
    mdbProgress,
    mdbBadge,
    mdbIcon
  },
  props: ["questions", "removable", "votable"],
  data() {
    return {
      id: Math.random() + "-"
    };
  },
  methods: {
    getRatio: function(q) {
      if (q.voteUp == 0 && q.voteDown == 0) return 50;
      return (
        (100 * Math.abs(q.voteUp)) /
        Math.max(1, Math.abs(q.voteUp) + Math.abs(q.voteDown))
      );
    },
    useQuestion: function(q) {
      this.$store.dispatch("questions/use", q);
      this.$router.push({
        name: "addConversation",
        params: {
          questionID: q.id
        }
      });
    }
  }
};
</script>

<style>
.max-size-long {
  max-height: 500px;
  overflow-y: auto;
}
.progress-min-width {
  min-width: 50px;
}
.material-icons {
  margin-left: 5px;
}
.progress.md-progress {
  background-color: #ff3547 !important;
}
</style>